import { type AdminCustomerCreate } from '@myre/app-user-generated/types/AdminCustomerCreate';
import { type AdminCustomerUpdate } from '@myre/app-user-generated/types/AdminCustomerUpdate';
import { type UserEvent } from '@myre/app-user-generated/types/UserEvent';

import { Action, ErrorAction } from '../../core/store/interfaces';

import { type Customer } from './interfaces';

export const ADMIN_ACTION_LEAVE = 'admin/ADMIN_ACTION_LEAVE';

export const ADMIN_ACTION_GET_USER_EVENTS_REQUEST =
  'admin/ADMIN_ACTION_GET_USER_EVENTS_REQUEST';
export const ADMIN_ACTION_GET_USER_EVENTS_SUCCESS =
  'admin/ADMIN_ACTION_GET_USER_EVENTS_SUCCESS';
export const ADMIN_ACTION_GET_USER_EVENTS_ERROR =
  'admin/ADMIN_ACTION_GET_USER_EVENTS_ERROR';

export const ADMIN_ACTION_GET_CUSTOMERS_REQUEST =
  'admin/ADMIN_ACTION_GET_CUSTOMERS_REQUEST';
export const ADMIN_ACTION_GET_CUSTOMERS_SUCCESS =
  'admin/ADMIN_ACTION_GET_CUSTOMERS_SUCCESS';
export const ADMIN_ACTION_GET_CUSTOMERS_ERROR =
  'admin/ADMIN_ACTION_GET_CUSTOMERS_ERROR';

export const ADMIN_ACTION_EXPORT_EXCEL_EXAMPLE_REQUEST =
  'admin/ADMIN_ACTION_EXPORT_EXCEL_EXAMPLE_REQUEST';
export const ADMIN_ACTION_EXPORT_EXCEL_EXAMPLE_SUCCESS =
  'admin/ADMIN_ACTION_EXPORT_EXCEL_EXAMPLE_SUCCESS';
export const ADMIN_ACTION_EXPORT_EXCEL_EXAMPLE_ERROR =
  'admin/ADMIN_ACTION_EXPORT_EXCEL_EXAMPLE_ERROR';

export const ADMIN_ACTION_UPDATE_CUSTOMER_REQUEST =
  'admin/ADMIN_ACTION_UPDATE_CUSTOMER_REQUEST';
export const ADMIN_ACTION_UPDATE_CUSTOMER_SUCCESS =
  'admin/ADMIN_ACTION_UPDATE_CUSTOMER_SUCCESS';
export const ADMIN_ACTION_UPDATE_CUSTOMER_ERROR =
  'admin/ADMIN_ACTION_UPDATE_CUSTOMER_ERROR';

export const ADMIN_ACTION_CREATE_CUSTOMER_REQUEST =
  'admin/ADMIN_ACTION_CREATE_CUSTOMER_REQUEST';
export const ADMIN_ACTION_CREATE_CUSTOMER_SUCCESS =
  'admin/ADMIN_ACTION_CREATE_CUSTOMER_SUCCESS';
export const ADMIN_ACTION_CREATE_CUSTOMER_ERROR =
  'admin/ADMIN_ACTION_CREATE_CUSTOMER_ERROR';

export const ADMIN_ACTION_UPLOAD_CUSTOMER_AVATAR_ERROR =
  'admin/ADMIN_ACTION_UPLOAD_CUSTOMER_AVATAR_ERROR';

export class GetUserEventsRequest extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_GET_USER_EVENTS_REQUEST;
}

export class GetUserEventsSuccess extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_GET_USER_EVENTS_SUCCESS;

  constructor(public userEvents: readonly UserEvent[]) {
    super();
  }
}

export class GetUserEventsError extends ErrorAction {
  public static override readonly type: string =
    ADMIN_ACTION_GET_USER_EVENTS_ERROR;
}

export class GetCustomersRequest extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_GET_CUSTOMERS_REQUEST;
}

export class GetCustomersSuccess extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_GET_CUSTOMERS_SUCCESS;

  constructor(public customers: readonly Customer[]) {
    super();
  }
}

export class GetCustomersError extends ErrorAction {
  public static override readonly type: string =
    ADMIN_ACTION_GET_CUSTOMERS_ERROR;
}

export class ExportExcelExampleRequest extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_EXPORT_EXCEL_EXAMPLE_REQUEST;

  constructor(public customer: Customer) {
    super();
  }
}

export class ExportExcelExampleSuccess extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_EXPORT_EXCEL_EXAMPLE_SUCCESS;
}

export class ExportExcelExampleError extends ErrorAction {
  public static override readonly type: string =
    ADMIN_ACTION_EXPORT_EXCEL_EXAMPLE_ERROR;
}

export class UpdateCustomerRequest extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_UPDATE_CUSTOMER_REQUEST;

  constructor(
    public customerId: number,
    public body: AdminCustomerUpdate,
  ) {
    super();
  }
}

export class UpdateCustomerSuccess extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_UPDATE_CUSTOMER_SUCCESS;

  constructor(public customer: Customer) {
    super();
  }
}

export class UpdateCustomerError extends ErrorAction {
  public static override readonly type: string =
    ADMIN_ACTION_UPDATE_CUSTOMER_ERROR;
}

export class CreateCustomerRequest extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_CREATE_CUSTOMER_REQUEST;

  constructor(public body: AdminCustomerCreate) {
    super();
  }
}

export class CreateCustomerSuccess extends Action {
  public static override readonly type: string =
    ADMIN_ACTION_CREATE_CUSTOMER_SUCCESS;

  constructor(public customer: Customer) {
    super();
  }
}

export class CreateCustomerError extends ErrorAction {
  public static override readonly type: string =
    ADMIN_ACTION_CREATE_CUSTOMER_ERROR;
}

export class LeaveAdmin extends Action {
  public static override readonly type: string = ADMIN_ACTION_LEAVE;
}

export class UploadCustomerAvatarError extends ErrorAction {
  public static override readonly type: string =
    ADMIN_ACTION_UPLOAD_CUSTOMER_AVATAR_ERROR;
}
